import { EventEmitter, Directive, ElementRef, Input, Output, NgModule } from '@angular/core';
import { interval, ReplaySubject } from 'rxjs';
import { takeUntil, filter, tap } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
const getDateNow = () => {
    return Math.floor(Date.now() / 1000);
};
const getCountdownResult = (secondes) => {
    return {
        seconds: Math.floor((secondes / 1) % 60),
        minutes: Math.floor((secondes / 1 / 60) % 60),
        hours: Math.floor((secondes / (1 * 60 * 60)) % 24),
        day: Math.floor(secondes / (1 * 60 * 60 * 24))
    };
};
const getLanguage = (language) => {
    if (language === 'fr') {
        return {
            timeago: 'il y a',
            now: "à l'instant",
            seconds: 's',
            minutes: 'm',
            hours: 'h',
            day: 'j'
        };
    }
    else if (language === 'de') {
        return {
            timeago: 'vor',
            now: 'gerade jetzt',
            seconds: 'z',
            minutes: 'm',
            hours: 's',
            day: 't'
        };
    }
    else if (language === 'pt') {
        return {
            timeago: 'há',
            now: 'agora mesmo',
            seconds: 's',
            minutes: 'm',
            hours: 's',
            day: 'd'
        };
    }
    else if (language === 'es') {
        return {
            timeago: 'hace',
            now: 'en este momento',
            seconds: 's',
            minutes: 'm',
            hours: 's',
            day: 'd'
        };
    }
    else if (language === 'cs') {
        return {
            timeago: 'před',
            now: 'právě teď',
            seconds: 's',
            minutes: 'm',
            hours: 'h',
            day: 'd'
        };
    }
    else if (language === 'pl') {
        return {
            timeago: 'jest',
            now: 'właśnie',
            seconds: 's',
            minutes: 'm',
            hours: 'g',
            day: 'd'
        };
    }
    else if (language === 'ge') {
        return {
            timeago: 'დასრულდა',
            now: 'დროა',
            seconds: 'წმ',
            minutes: 'წთ',
            hours: 'სთ',
            day: 'დღე'
        };
    }
    else {
        return {
            timeago: 'there is',
            now: 'just now',
            seconds: 's',
            minutes: 'm',
            hours: 'h',
            day: 'd'
        };
    }
};

class NgxSimpleCountdownDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.endMessage = 'countdown finish';
        this.language = 'en';
        this.reactive = true;
        this.styles = 'font-size:20px;color:#FFF;background-color:#000;padding:10px 5px;font-weight:bold;min-width:40px;text-align:center;';
        this.finish = new EventEmitter();
    }
    ngOnInit() {
        this.dateNow = getDateNow();
        this.keywords = getLanguage(this.language);
        this.initSimpleCountdown();
    }
    ngOnDestroy() { }
    initSimpleCountdown() {
        this.totalSecondes = this.dateTo - this.dateNow;
        this.updateSimpleCountdown(this.totalSecondes);
        this.interval$ = interval(1000).pipe(takeUntil(this.componentDestroyed(this)), filter((_) => this.reactive && this.totalSecondes > 0), tap((_) => {
            this.totalSecondes--;
            this.updateSimpleCountdown(this.totalSecondes);
        }));
        if (this.reactive) {
            this.interval$.subscribe();
        }
    }
    createHTML(data) {
        const { day, hours, minutes, seconds } = data;
        let o = '';
        if (this.totalSecondes > 0) {
            o = '<div style="display:flex;">';
            if (day > 0) {
                o += `<div style="${this.styles}">
          ${day}${this.keywords.day}
          </div>`;
            }
            if (hours > 0 || day > 0) {
                o += `<div style="${this.styles}">
          ${hours}${this.keywords.hours}
        </div>`;
            }
            if ((minutes > 0 || hours > 0 || day > 0) && this.reactive) {
                o += `<div style="${this.styles}">
          ${minutes}${this.keywords.minutes}
        </div>`;
            }
            if ((seconds > 0 || minutes > 0 || hours > 0 || day > 0) &&
                this.reactive) {
                o += `<div style="${this.styles}">
          ${seconds}${this.keywords.seconds}
        </div>`;
            }
            o += '</div>';
        }
        else {
            this.finish.emit();
            if (this.endMessage !== '') {
                o += `<div style="${this.styles}">${this.endMessage}</div>`;
            }
        }
        this.elementRef.nativeElement.innerHTML = o;
    }
    updateSimpleCountdown(secondes) {
        const countdownResult = getCountdownResult(secondes);
        this.createHTML(countdownResult);
    }
    componentDestroyed(component) {
        const oldNgOnDestroy = component.ngOnDestroy;
        const destroyed$ = new ReplaySubject(1);
        component.ngOnDestroy = () => {
            oldNgOnDestroy.apply(component);
            destroyed$.next(undefined);
            destroyed$.complete();
        };
        return destroyed$;
    }
}
NgxSimpleCountdownDirective.ɵfac = function NgxSimpleCountdownDirective_Factory(t) { return new (t || NgxSimpleCountdownDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NgxSimpleCountdownDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: NgxSimpleCountdownDirective, selectors: [["", "simpleCountdown", ""]], inputs: { endMessage: "endMessage", language: "language", reactive: "reactive", styles: "styles", dateTo: "dateTo" }, outputs: { finish: "finish" } });
NgxSimpleCountdownDirective.ctorParameters = () => [
    { type: ElementRef }
];
NgxSimpleCountdownDirective.propDecorators = {
    dateTo: [{ type: Input }],
    endMessage: [{ type: Input }],
    language: [{ type: Input }],
    reactive: [{ type: Input }],
    styles: [{ type: Input }],
    finish: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxSimpleCountdownDirective, [{
        type: Directive,
        args: [{
                selector: '[simpleCountdown]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { endMessage: [{
            type: Input
        }], language: [{
            type: Input
        }], reactive: [{
            type: Input
        }], styles: [{
            type: Input
        }], finish: [{
            type: Output
        }], dateTo: [{
            type: Input
        }] }); })();

class NgxSimpleTimeagoDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.language = 'en';
        this.reactive = true;
    }
    ngOnInit() {
        this.dateNow = getDateNow();
        this.keywords = getLanguage(this.language);
        this.initSimpleCountdown();
    }
    ngOnDestroy() { }
    initSimpleCountdown() {
        this.totalSecondes = this.dateNow - this.date;
        this.updateSimpleCountdown(this.totalSecondes);
        this.interval$ = interval(20000).pipe(takeUntil(this.componentDestroyed(this)), filter(() => this.reactive && this.totalSecondes > 0), tap(() => {
            this.totalSecondes += 20;
            this.updateSimpleCountdown(this.totalSecondes);
        }));
        if (this.reactive) {
            this.interval$.subscribe();
        }
    }
    createHTML(data) {
        const { day, hours, minutes } = data;
        let o = '';
        if (this.totalSecondes > 0) {
            if (this.totalSecondes <= 60) {
                o += this.keywords.now;
            }
            else {
                o += `${this.keywords.timeago} `;
                if (data.day > 0) {
                    o += `${data.day}${this.keywords.day} `;
                }
                if (hours > 0 || day > 0) {
                    o += `${hours}${this.keywords.hours} `;
                }
                if (minutes > 0 || hours > 0 || day > 0) {
                    o += `${minutes}${this.keywords.minutes} `;
                }
            }
        }
        this.elementRef.nativeElement.innerHTML = o;
    }
    updateSimpleCountdown(secondes) {
        const countdownResult = getCountdownResult(secondes);
        this.createHTML(countdownResult);
    }
    componentDestroyed(component) {
        const oldNgOnDestroy = component.ngOnDestroy;
        const destroyed$ = new ReplaySubject(1);
        component.ngOnDestroy = () => {
            oldNgOnDestroy.apply(component);
            destroyed$.next(undefined);
            destroyed$.complete();
        };
        return destroyed$;
    }
}
NgxSimpleTimeagoDirective.ɵfac = function NgxSimpleTimeagoDirective_Factory(t) { return new (t || NgxSimpleTimeagoDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NgxSimpleTimeagoDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: NgxSimpleTimeagoDirective, selectors: [["", "simpleTimeago", ""]], inputs: { language: "language", reactive: "reactive", date: "date" } });
NgxSimpleTimeagoDirective.ctorParameters = () => [
    { type: ElementRef }
];
NgxSimpleTimeagoDirective.propDecorators = {
    date: [{ type: Input }],
    language: [{ type: Input }],
    reactive: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxSimpleTimeagoDirective, [{
        type: Directive,
        args: [{
                selector: '[simpleTimeago]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { language: [{
            type: Input
        }], reactive: [{
            type: Input
        }], date: [{
            type: Input
        }] }); })();

class NgxSimpleCountdownModule {
}
NgxSimpleCountdownModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgxSimpleCountdownModule });
NgxSimpleCountdownModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NgxSimpleCountdownModule_Factory(t) { return new (t || NgxSimpleCountdownModule)(); }, imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxSimpleCountdownModule, { declarations: [NgxSimpleCountdownDirective, NgxSimpleTimeagoDirective], exports: [NgxSimpleCountdownDirective, NgxSimpleTimeagoDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxSimpleCountdownModule, [{
        type: NgModule,
        args: [{
                declarations: [NgxSimpleCountdownDirective, NgxSimpleTimeagoDirective],
                imports: [],
                exports: [NgxSimpleCountdownDirective, NgxSimpleTimeagoDirective]
            }]
    }], null, null); })();

/*
 * Public API Surface of ngx-simple-countdown
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxSimpleCountdownDirective, NgxSimpleCountdownModule, NgxSimpleTimeagoDirective };

//# sourceMappingURL=ngx-simple-countdown.js.map